import { Component, OnInit, inject, signal, ViewChild, ElementRef, effect } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ChatService } from '../../services/chat.service';

@Component({
  selector: 'app-chat',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './chatbot.html'
})
export class ChatComponent implements OnInit {
  // Inject the service
  chatService = inject(ChatService);
  
  // 1. Bind directly to the service's signal!
  messages = this.chatService.messages;
  
  userInput = signal('');
  isLoading = signal(false);

  @ViewChild('chatContainer') private chatContainer!: ElementRef;

  constructor() {
    // 2. Angular Effect: Automatically scroll to bottom whenever 'messages' change
    effect(() => {
      this.messages(); // This tells Angular to track this signal
      this.scrollToBottom();
    });
  }

  ngOnInit() {
    // 3. Ask service to load history (it will ignore if already loaded)
    this.chatService.loadHistory();
  }

  sendMessage() {
    const text = this.userInput().trim();
    if (!text || this.isLoading()) return;

    this.userInput.set('');
    this.isLoading.set(true);

    // Send the message via the service
    this.chatService.sendMessage(text).subscribe({
      next: () => {
        this.isLoading.set(false);
      },
      error: () => {
        this.chatService.messages.update(msgs => [...msgs, { role: 'ai', content: 'Sorry, an error occurred.' }]);
        this.isLoading.set(false);
      }
    });
  }

  private scrollToBottom() {
    setTimeout(() => {
      if (this.chatContainer) {
        this.chatContainer.nativeElement.scrollTop = this.chatContainer.nativeElement.scrollHeight;
      }
    }, 50); // Small delay to allow DOM to render the new message first
  }
}